import React from 'react'
import debounce from 'lodash/debounce'
import * as Sentry from '@sentry/browser'
import * as Status from './StatusMessage'

const ERROR_WAIT = 1000
const ERROR_MAX_WAIT = 2000

export default function (options, Component) {
  if (options && !Component) {
    Component = options
    options = {}
  }
  return class WithErrorBoundary extends React.Component {
    state = {}

    static getDerivedStateFromError (error) {
      return { error }
    }

    componentDidCatch (error, info) {
      console.error('caught', { error, info })
      Sentry.withScope(scope => {
        scope.setExtras(info)
        const eventId = Sentry.captureException(error)
        this.setState({ eventId })
      })
      this.showError()
    }

    setError (...err) {
      this.setState(...err)
    }

    showError = debounce(() => {
      this.setState({ showError: true })
    }, {
      wait: ERROR_WAIT,
      maxWait: ERROR_MAX_WAIT
    })

    componentDidUpdate () {
      if (this.state.error && !this.state.showError) {
        this.showError()
      }
    }

    unsetError () {
      if (this.state.error) {
        this.setState({ error: undefined })
      }
    }

    render () {
      if (this.state.error) {
        if (options.minimal) return <Status.ErrorIcon />
        if (!this.state.showError) return null
        const { error } = this.state
        return (
          <Status.Select type={error.errorType || 'error'} title='Sorry, an error occurred.'>
            <div className='code'>
              {error.message.slice(0, 256)}
            </div>

            <div className='buttons'>
              <button type='button' className='button' onClick={() => document.location.reload()}>Reload</button>
              <button type='button' className='button' onClick={() => Sentry.showReportDialog({ eventId: this.state.eventId })}>Report</button>
            </div>
          </Status.Select>
        )
      }
      return <Component {...this.props} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js